import { render, staticRenderFns } from "./MasterCpl.vue?vue&type=template&id=06bf9ba3&scoped=true&"
import script from "./MasterCpl.vue?vue&type=script&lang=js&"
export * from "./MasterCpl.vue?vue&type=script&lang=js&"
import style0 from "./MasterCpl.vue?vue&type=style&index=0&id=06bf9ba3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf9ba3",
  null
  
)

export default component.exports